import WebFontLoader from 'phaser3-rex-plugins/plugins/webfontloader.js'

export enum MULTIPLIER_KENO_SNAKES_TEXTURE_KEYS {
  ATLAS_NAME = 'MULTIPLIER_KENO_SNAKES_ATLAS',
  CIRCLE_BLUE_LARGE = 'MULTIPLIER_KENO_SNAKES_CIRCLE_BLUE_LARGE',
  CIRCLE_BLUE_SMALL = 'MULTIPLIER_KENO_SNAKES_CIRCLE_BLUE_SMALL',
}

export enum MULTIPLIER_KENO_SNAKES_ATLAS_KEYS {
  BACKGROUND = 'background.png',
  CIRCLE_YELLOW_LARGE = 'circle-yellow-large.png',
  CIRCLE_YELLOW_OUTLINE_LARGE = 'circle-yellow-outline-large.png',
  CIRCLE_BLUE_LARGE = 'circle-blue-large.png',
  CIRCLE_BLUE_OUTLINE_SMALL = 'circle-blue-outline-small.png',
  CIRCLE_BLUE_SMALL = 'circle-blue-small.png',
  FONT = 'MULTIPLIER_KENO_SNAKES_FONT',
  FOREGROUND = 'foreground.png',
  PULSE_SMALL_0 = 'pulse-small-0.png',
  PULSE_SMALL_1 = 'pulse-small-1.png',
  PULSE_LARGE_0 = 'pulse-large-0.png',
  PULSE_LARGE_1 = 'pulse-large-1.png',
  SNAKE_TRAIL_PARTICLE = 'particle-trail-circle.png',
}

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/add-ons/multiplier/keno-snakes/`

  WebFontLoader.call(scene.load, {
    custom: {
      families: ['Jost'],
      urls: [`${prefix}fonts.css`],
    },
  })

  if (!scene.textures.getTextureKeys().includes(MULTIPLIER_KENO_SNAKES_TEXTURE_KEYS.ATLAS_NAME)) {
    scene.load.atlas(
      MULTIPLIER_KENO_SNAKES_TEXTURE_KEYS.ATLAS_NAME,
      `${prefix}multiplier-keno-snakes-images.png`,
      `${prefix}multiplier-keno-snakes-images.json`,
    )
  }
}
